import React from 'react';
import { Shield, Building, Award, Calendar } from 'lucide-react';

interface ProfileSidebarProps {
  user: any;
  joinedDate: string;
}

export function ProfileSidebar({ user, joinedDate }: ProfileSidebarProps) {
  const isSuperAdmin = user.role === 'SuperAdmin';

  return (
    <div style={{
      padding: '20px',
      borderRadius: '0',
      border: '1px solid var(--admin-card-border)',
      backgroundColor: 'var(--admin-card-bg)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      gap: '14px',
      height: '460px',
      boxSizing: 'border-box'
    }}>
      {/* Square Geometric Avatar */}
      <div style={{
        width: '60px',
        height: '60px',
        borderRadius: '0',
        backgroundColor: 'rgba(56, 189, 248, 0.08)',
        border: '1px solid var(--admin-card-border)',
        color: 'var(--admin-card-text)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '22px',
        fontWeight: 700,
        fontFamily: "'Space Grotesk', sans-serif",
        position: 'relative',
        flexShrink: 0
      }}>
        {user.name ? user.name.charAt(0).toUpperCase() : 'A'}
      </div>

      <div>
        <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '15px', fontWeight: 700, color: 'var(--admin-card-text)', margin: '0 0 2px 0' }}>
          {user.name || 'Administrator'}
        </h3>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: '12px', color: 'var(--admin-card-subtext)', margin: 0 }}>
          {user.email}
        </p>
      </div>

      {/* Metadata List */}
      <div style={{
        width: '100%',
        borderTop: '1px solid var(--admin-card-border)',
        paddingTop: '14px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        textAlign: 'left',
        marginTop: 'auto'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Shield size={14} style={{ color: '#38bdf8', flexShrink: 0 }} />
          <div>
            <span style={{ color: 'var(--admin-card-subtext)', fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', display: 'block', letterSpacing: '0.05em' }}>System Role</span>
            <span style={{ color: 'var(--admin-card-text)', fontSize: '12px', fontWeight: 600, fontFamily: "'Inter', sans-serif" }}>{user.role || 'Admin'}</span>
          </div>
        </div>

        {!isSuperAdmin && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Building size={14} style={{ color: '#3b82f6', flexShrink: 0 }} />
              <div>
                <span style={{ color: 'var(--admin-card-subtext)', fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', display: 'block', letterSpacing: '0.05em' }}>Workspace Role</span>
                <span style={{ color: 'var(--admin-card-text)', fontSize: '12px', fontWeight: 600, fontFamily: "'Inter', sans-serif", textTransform: 'capitalize' }}>
                  {user.orgRole || 'Member'}
                </span>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Award size={14} style={{ color: '#10b981', flexShrink: 0 }} />
              <div>
                <span style={{ color: 'var(--admin-card-subtext)', fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', display: 'block', letterSpacing: '0.05em' }}>Current Plan</span>
                <span style={{
                  color: user.plan === 'enterprise' ? '#10b981' : user.plan === 'scale' ? '#38bdf8' : 'var(--admin-card-subtext)',
                  fontSize: '12px',
                  fontWeight: 700,
                  fontFamily: "'Space Grotesk', sans-serif",
                  textTransform: 'uppercase'
                }}>
                  {user.plan || 'Freemium'}
                </span>
              </div>
            </div>
          </>
        )}

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Calendar size={14} style={{ color: '#8b5cf6', flexShrink: 0 }} />
          <div>
            <span style={{ color: 'var(--admin-card-subtext)', fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', display: 'block', letterSpacing: '0.05em' }}>Member Since</span>
            <span style={{ color: 'var(--admin-card-text)', fontSize: '12px', fontWeight: 600, fontFamily: "'Inter', sans-serif" }}>{joinedDate}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
